<template>
  <div class="px-4" v-if="visibleItems.length > 0">
    <div class="flex justify-between items-center gap-4 mb-4">
      <div class="text-xs text-text">{{ heading }}</div>
      <div class="h-px bg-surface-grey flex-1"></div>

      <div
        class="flex"
        v-if="showEdit || showRemove"
      >

        <button 
          @click="props.type === 'upsaleTicket' ? cart.gotoUpsaleReservation(id) : cart.gotoTicketReservation(id)"
          type="button"
          class="text-xs underline ml-4 cursor-pointer"
          v-if="showEdit"
        >
          {{ $t('common.edit') }}
        </button>

        <button
          @click="cart.removeTypeFromCart(id, props.type, true)"
          type="button"
          class="text-xs underline ml-4 cursor-pointer"
          v-if="showRemove"
        >
          {{ $t('common.remove') }}
        </button>
      </div>
    </div>
    <div class="space-y-2">
      <div v-for="item in visibleItems" :key="item.id" class="flex justify-between">
        <div class="flex items-center gap-1 min-w-0">
          <div class="flex items-start gap-1 min-w-0">
            <span class="font-semibold whitespace-nowrap"
              >{{ item.count }} {{ $t('common.pcs') }}</span
            >
            <span class="text-text">·</span>
            <div class="min-w-0">
              <div class="text-text truncate">{{ props.type === 'upsaleTicket' ? item.upsale_title : getLocalizedTicketValue(item, locale, 'name1') }}</div>
              <div class="text-xs text-text">
                <span v-if="item.flexData">
                  <!--button
                    type="button"
                    class="underline mr-1 cursor-pointer"
                    @click="infoModal = true"
                  >
                    {{ $t('checkout.show_info') }}
                  </button-->
                  <div v-for="flexdata in item.flexData" :key="flexdata" class="text-xs text-text">
                    <p>{{ flexdata }}</p>
                  </div>
                </span>
                <span v-if="item.discountText">
                  {{ item.discountText }}
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="font-semibold" v-if="item.price">
          <span v-if="item.price_groups?.length > 0 && cart.confirmedSeatPrices[item.id] == null" class="text-xs font-normal text-text mr-1">{{ $t('common.from') }}</span>{{
            item.price_groups?.length > 0
              ? (cart.confirmedSeatPrices[item.id] != null
                  ? formatPrice(cart.confirmedSeatPrices[item.id], item.currency, $i18n.locale)
                  : formatPrice(item.min_price * item.count, item.currency, $i18n.locale))
              : formatPrice(item.price * item.count, item.currency, $i18n.locale)
          }}
        </div>
      </div>
    </div>

    <BaseModal v-model="infoModal">
      <template #header>{{ $t('checkout.ticket_info') }}</template>

      <div class="p-6">
        <div class="font-semibold mb-4">#1 billet</div>
        <div class="text-sm">
          <div class="font-semibold mb-2">Program</div>
          <div class="space-y-2 text-text">
            <p>
              Her kan du tilføje informationer om din billet. Det kan være
              allergener, madpræferencer eller andre relevante oplysninger.
            </p>
            <p>
              Villads Leth - AI Agenter - Sådan bruger du dem til at 10x din
              produktivitet
            </p>
            <p>
              Mads Haukrogh - Go Big or Go Home - The Power of Big Splash
              Campaigns
            </p>
            <p>
              Malte Lange - 6 skarpe LinkedIn Ads-hacks: Få flere og bedre leads
              - uden at øge dit budg
            </p>
            <p>
              Bonnie Groth Frølund - Marketingchefens guide: Leadgenerering for
              B2B virksomheder
            </p>
          </div>
        </div>

        <div class="mt-4">
          <div class="font-semibold mb-2 text-sm">Deltager info</div>
          <div class="grid grid-cols-2 gap-4">
            <div>
              <div class="text-text text-xs">Deltager for- og efternavn</div>
              <div class="text-sm">Malte Lange</div>
            </div>
            <div>
              <div class="text-text text-xs">Deltager e-mail</div>
              <div class="text-sm">kd@29x.studio</div>
            </div>
          </div>
        </div>
      </div>
    </BaseModal>
  </div>
</template>

<script setup lang="ts">
  import { computed, ref } from 'vue';
  import { useI18n } from 'vue-i18n';

  import { useCartStore } from '@/stores/cart';
  import type { Ticket,UpsaleTicket } from '@/types';
  import { formatPrice } from '@/utils/formatPrice';
  import { getLocalizedTicketValue } from '@/utils/ticketItemUtil';

  import BaseModal from '../ui/BaseModal.vue';

  const cart = useCartStore();

  const infoModal = ref(false);

  const { locale } = useI18n();

  const props = defineProps<{
    heading: string;
    type: 'upsaleTicket' | 'ticket';
    id: number | string;
    items: UpsaleTicket[] | Ticket[];
    showEdit: boolean;
    showRemove: boolean;
  }>();

  // Filter items to only include those with count > 0
  const visibleItems = computed(() => (props.items ?? []).filter(item => item.count > 0));


</script>
